import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { TIPO_NOTIFICACION, TIPO_PERFIL } from '@/constantes/usuarios.js'
import moment from 'moment'
import axios from 'axios'
const db = firebase.firestore()
var cargadorListaNotif = null

const store = {
  state: {
    lista_notificaciones_local: [],
    lista_notificaciones: []
  },
  getters: {
    lista_notificaciones: state => {
      return state.lista_notificaciones
    },
    lista_notificaciones_local: state => {
      return state.lista_notificaciones_local
    }
  },
  mutations: {
    ASIGNA_LISTA_NOTIFICACIONES(state, lista_notificaciones) {
      state.lista_notificaciones = lista_notificaciones
    },
    ASIGNA_LISTA_NOTIFICACIONES_LOCAL(state, lista_notificaciones_local) {
      state.lista_notificaciones_local = lista_notificaciones_local
    }
  },
  actions: {
    cargaNotificaciones({ commit, getters }) {
      var idFranquicia = getters.usuario.id_franquicia
      var idUsuario = getters.usuario.id
      //console.log("TCL: getters.usuario",getters.usuario)

      if (cargadorListaNotif === null) {
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(idFranquicia)
          .collection('NTFUsuarios')
          .doc(idUsuario)
        cargadorListaNotif = docPath.onSnapshot(doc => {
          commit('ASIGNA_LISTA_NOTIFICACIONES', doc.data())
          commit('ASIGNA_LISTA_NOTIFICACIONES_LOCAL', doc.data())
        })
      }
    },
    actualizarNotificaciones({ getters }, index) {
      var idFranquicia = getters.usuario.id_franquicia
      var idUsuario = getters.usuario.id
      var notificaciones = getters.lista_notificaciones_local

      notificaciones.inmediatas[index].leida = true
      let docPath = db
        .collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(idFranquicia)
        .collection('NTFUsuarios')
        .doc(idUsuario)
      return docPath.set(notificaciones)
    },

    enviarNTF({ dispatch, getters }, notificacion) {
      console.log('getters.franquicia.id: ' + getters.franquicia.id)
      if (notificacion.tipo === TIPO_NOTIFICACION.PROGRAMADA) {
        return dispatch('enviarNTFProgramada', notificacion)
      } else if (notificacion.tipo === TIPO_NOTIFICACION.INMEDIATA) {
        return dispatch('enviarNTFInmediata', notificacion)
      }
    },
    enviarNTFEmail({}, notificacion) {
      return new Promise((resolve, reject) => {
        var formDa = new FormData()
        formDa = notificacion
        axios
          .post('https://app.pixancloud.com/ws/email/', formDa)
          .then(response => {
            console.log('Mensaje enviado')
            console.log(response)
            resolve(response)
          })
          .catch(error => {
            console.log('Error')
            console.log(error)
            reject(error)
          })
      })
    },
    enviarNTFInmediata({ getters }, notificacion) {
      return new Promise((resolve, reject) => {
        console.log('enviarNTFInmediata: ', notificacion)
        var docId = ''
        if (notificacion.info.grupo) {
          docId = 'Grupo-' + moment().format('YYYY-MM-DD')
        } else {
          docId = notificacion.info.id
        }
        // Añadir logo Franquicia
        let urlFoto = getters.franquicia.foto.url
        notificacion.info.data.contenido +=
          '<br/><br/><img src = "' + urlFoto + '" height="100"/>'

        let coll =
          notificacion.info.perfil === TIPO_PERFIL.PROPIETARIO
            ? FS_COLLECTIONS.NTF_PROPIETARIOS
            : FS_COLLECTIONS.NTF_USUARIOS
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(coll + '_Envio')
          .doc(docId)

        docPath.get().then(doc => {
          var datos = {}
          if (!doc.exists) {
            datos.inmediatas = [notificacion.info]
            docPath.set(datos)
            if (notificacion.info.grupo === undefined) {
              db.collection(FS_COLLECTIONS.FRANQUICIAS)
                .doc(getters.franquicia.id)
                .collection(coll)
                .doc(docId)
                .set({ inmediatas: [] })
            }
          } else {
            datos.inmediatas = firebase.firestore.FieldValue.arrayUnion(
              notificacion.info
            )
            docPath.update(datos)
          }
        })
        resolve(true)
      })
    },
    enviarNTFProgramada({ getters }, notificacion) {
      return new Promise((resolve, reject) => {
        console.log(notificacion)
        let fecha = notificacion.fecha
        let docPath = db
          .collection(FS_COLLECTIONS.FRANQUICIAS)
          .doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.NTF_PROGRAMADAS)
          .doc(fecha)

        // Añadir logo Franquicia
        let urlFoto = getters.franquicia.foto.url
        notificacion.info.data.contenido +=
          '<br/><br/><img src = "' + urlFoto + '" height="100"/>'

        docPath.get().then(doc => {
          var datos = {}
          if(notificacion.modulo!==undefined){
            notificacion.info.modulo = notificacion.modulo;
          }
          if (!doc.exists) {
            datos.notificaciones = [notificacion.info]
            docPath.set(datos)
          } else {
            datos.notificaciones = firebase.firestore.FieldValue.arrayUnion(
              notificacion.info
            )
            docPath.update(datos)
          }
        })
        resolve(true)
      })
    },
    registrarToken({ getters }, token) {
      var devices = []
      let usuario = getters.usuario
      if (usuario.devices !== undefined) {
        devices = usuario.devices
      }

      var newDevices = devices.filter(device => {
        return device.token !== token
      })
      let thisDevice = {
        token: token,
        last_login: firebase.firestore.Timestamp.fromDate(new Date()),
        name: navigator.userAgent
      }

      console.log(thisDevice)
      newDevices.push(thisDevice)
      db.collection('Usuarios')
        .doc(usuario.id)
        .update({ devices: newDevices })
    }
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/notificaciones/notificaciones.js